import { DEFAULT_PAGE_SIZE, Pages } from "./pages";
import { UsersDetailFilter, UsersDetailFilterParams } from "./users-detail-filter";
import { ListSortOrder } from "./list-sort-order";

export class FindUsersDetailsRequest {
    constructor(private pages: Pages, private filter: UsersDetailFilter, private order?: ListSortOrder) {
    }

    static createUsersDetailsRequest(page: number, params?: UsersDetailFilterParams, pageSize?: number): FindUsersDetailsRequest {
        return new FindUsersDetailsRequest(
            new Pages(pageSize ?? DEFAULT_PAGE_SIZE, page),
            UsersDetailFilter.createUserDetailsFilter(params));
    }
}
